import React, { useMemo } from 'react';

const BASE = process.env.PUBLIC_URL;

const srcFor = (px) => {
  if (px >= 160) return `${BASE}/logo512.png`;
  if (px >= 56) return `${BASE}/logo192.png`;
  if (px >= 28) return `${BASE}/logo.png`;
  return `${BASE}/favicon.png`;
};

const SRC_SET = [
  `${BASE}/favicon.png 32w`,
  `${BASE}/logo.png 64w`,
  `${BASE}/logo192.png 192w`,
  `${BASE}/logo512.png 512w`,
  `${BASE}/logo672.png 672w`,
].join(', ');

const VARIANTS = {
  nav: {
    title: 'text-base sm:text-lg font-black tracking-tight text-slate-900 dark:text-white',
    subtitle: 'text-[9px] sm:text-[11px] font-semibold text-slate-500 dark:text-slate-400 leading-tight',
    short: false,
    img: 'drop-shadow-[0_2px_8px_rgba(0,0,0,0.12)]',
  },
  hero: {
    title: 'text-2xl sm:text-3xl font-serif font-bold text-white leading-none',
    subtitle: 'text-xs sm:text-sm font-medium text-white/75 leading-snug max-w-[210px]',
    short: false,
    img: 'drop-shadow-[0_4px_16px_rgba(0,0,0,0.35)]',
  },
  sidebar: {
    title: 'text-lg font-serif font-bold text-white leading-none',
    subtitle: 'text-[8px] font-bold text-slate-400 leading-[1.35] tracking-wide uppercase max-w-[148px]',
    short: false,
    img: 'drop-shadow-[0_2px_6px_rgba(0,0,0,0.25)]',
  },
  compact: {
    title: 'text-sm font-black text-slate-900 dark:text-white leading-none',
    subtitle: 'text-[8px] font-semibold text-slate-500 dark:text-slate-400 leading-tight max-sm:hidden sm:block',
    short: true,
    img: 'drop-shadow-[0_2px_6px_rgba(0,0,0,0.1)]',
  },
  footer: {
    title: 'text-base font-black text-white leading-none',
    subtitle: 'text-[10px] font-medium text-slate-400 leading-snug max-w-[180px]',
    short: false,
    img: 'drop-shadow-[0_2px_8px_rgba(0,0,0,0.2)]',
  },
};

const SUBTITLE_FULL = 'Yüzme ve Sualtı Sporları Kulübü';
const SUBTITLE_SHORT = 'Yüzme · Sualtı Kulübü';

/**
 * Atletik kulüp logosu — şeffaf arka planlı, tüm ekranlarda aynı kaynak.
 */
const Logo = ({
  size = 40,
  showText = false,
  variant = 'nav',
  className = '',
  imgClassName = '',
  onClick,
}) => {
  const styles = VARIANTS[variant] || VARIANTS.nav;
  const subtitle = styles.short ? SUBTITLE_SHORT : SUBTITLE_FULL;
  const src = useMemo(() => srcFor(size), [size]);

  return (
    <div
      className={`flex items-center gap-2.5 min-w-0 ${onClick ? 'cursor-pointer' : ''} ${className}`}
      onClick={onClick}
      role={onClick ? 'button' : undefined}
      tabIndex={onClick ? 0 : undefined}
      onKeyDown={onClick ? (e) => e.key === 'Enter' && onClick(e) : undefined}
    >
      <img
        src={src}
        srcSet={SRC_SET}
        sizes={`${size}px`}
        alt="Atletik Yüzme ve Sualtı Sporları Kulübü"
        width={size}
        height={size}
        className={`object-contain shrink-0 select-none ${styles.img} ${imgClassName}`}
        draggable={false}
        decoding="async"
      />
      {showText && (
        <div className="min-w-0 leading-none">
          <span className={`block ${styles.title}`}>Atletik</span>
          <span className={`block mt-0.5 ${styles.subtitle}`}>{subtitle}</span>
        </div>
      )}
    </div>
  );
};

export default Logo;
